module.exports = __webpack_public_path__ + "static/sectionbefore-ad794a56908d85f42696aadf1c4799e0.png";